import { checkFunction } from '@geek/yum-freight-framework/src/directives/functionIndex'

export const GO_FREIGHT_FUNCTION_KEY = 'giga_go_freight'

const ENGLISH_NAME_PROPS = new Set(['surchargeEnName', 'customerNameEn', 'nameEn'])
const ENGLISH_NAME_FIELDS = new Set(['customerNameEn'])

export function isGoFreightUser() {
  try {
    if (sessionStorage.getItem(GO_FREIGHT_FUNCTION_KEY) === '1') {
      return true
    }
  } catch (e) {
    // ignore
  }
  return checkFunction(GO_FREIGHT_FUNCTION_KEY)
}

export function isEnglishNameField(item) {
  if (!item) return false
  if (item.prop && ENGLISH_NAME_PROPS.has(item.prop)) return true
  if (item.field && ENGLISH_NAME_FIELDS.has(item.field)) return true
  if (item.props === 'customerNameEn') return true
  return false
}

export function filterEnglishNameList(list) {
  if (!isGoFreightUser() || !Array.isArray(list)) return list
  return list.filter(item => !isEnglishNameField(item))
}

export function filterEnglishNameTableSource(tableSource) {
  if (!tableSource || !isGoFreightUser()) return tableSource
  if (Array.isArray(tableSource.allColumn)) {
    tableSource.allColumn = filterEnglishNameList(tableSource.allColumn)
  }
  if (Array.isArray(tableSource.allFilterField)) {
    tableSource.allFilterField = filterEnglishNameList(tableSource.allFilterField)
  }
  return tableSource
}

export function syncGoFreightTableColumns(vm) {
  if (!vm || !isGoFreightUser()) return
  if (vm.$options.name === 'YunTableList' && Array.isArray(vm.tableSource?.allColumn)) {
    filterEnglishNameTableSource(vm.tableSource)
    vm.tableColumn = filterEnglishNameList(vm.tableSource.allColumn)
    const tableNav = vm.$refs?.tableNav
    if (tableNav?.columnData?.selectColumn) {
      tableNav.columnData.selectColumn = filterEnglishNameList(tableNav.columnData.selectColumn)
    }
  }
  vm.$children?.forEach(syncGoFreightTableColumns)
}
